import Plyr from 'plyr'

import { clearTimers } from '@utils/utils'

import BaseComponent from './_BaseComponent'




/* LATEST VIDEOS
----------------------------------------------------------------------------------------------------*/

export default class LatestVideos extends BaseComponent {

    constructor($el, namespace) {
        super('LV', $el, namespace)


        this.currentSlideIndex = 0

        this.pageWillChangeHandler = () => { this.onPageWillChange() }


        this.getVideos()
        this.initSlider()
        this.on()
    }


    bindEvents() {
        const { $playBtn, $closeBtn } = this.$refs


        this.addListeners(
            // User input
            [$playBtn, 'click', this.clickHandler],
            [$closeBtn, 'click', this.closeClickHandler],

            // Nav events
            [document, 'pageWillChange', this.pageWillChangeHandler],
        )
    }




    /* Handlers
    --------------------------------------------------------- */

    onPlayButtonClick(e, video, isInstant) {
        e.preventDefault()

        if (video.isPlaying) return


        clearTimers([this.playTimer, this.interactiveTimer, this.initPlayerTimer, this.initInteractiveTimer])


        this.videos.forEach((v) => {
            const wasPlaying = v.isPlaying
            const isCurrent = v.index === video.index

            v.$video.classList.toggle('is-current', isCurrent)
            v.$thumb.classList.toggle('is-selected', isCurrent)
            v.$bg.classList.toggle('is-current', isCurrent)

            v.isPlaying = isCurrent

            if (v.isPlaying === wasPlaying) return

            if (!v.Player) {
                if (isCurrent) {
                    this.initPlayer(v, true)
                }
            } else {
                this.playTimer = setTimeout(() => {
                    v.$video.classList.toggle('is-playing', isCurrent)

                    if (isCurrent) {
                        v.Player.play()
                    } else {
                        v.Player.stop()
                    }
                }, isInstant ? 0 : 500)

                this.interactiveTimer = setTimeout(() => {
                    v.$video.classList.toggle('is-interactive', isCurrent)
                }, 2000)
            }
        })
    }


    onNavButtonClick(e, dir) {
        e.preventDefault()

        const { $prevBtn, $nextBtn } = this.$refs


        if ((dir === 'prev' && this.isAtStart) || (dir === 'next' && this.isAtEnd)) {
            return
        }

        this.currentSlideIndex = (dir === 'prev')
            ? this.currentSlideIndex - 1
            : this.currentSlideIndex + 1

        this.videos.forEach((v) => {
            v.$thumb.classList.toggle('is-hidden', v.groupIndex !== this.currentSlideIndex)
            v.$thumb.classList.toggle('is-prev', v.groupIndex < this.currentSlideIndex)
            v.$thumb.classList.toggle('is-next', v.groupIndex > this.currentSlideIndex)
        })


        this.isAtEnd = this.maxSlideIndex === this.currentSlideIndex
        this.isAtStart = this.currentSlideIndex === 0


        $prevBtn[0].toggleAttribute('disabled', this.isAtStart)
        $nextBtn[0].toggleAttribute('disabled', this.isAtEnd)
    }


    onPageWillChange() {
        this.toggle(false)
    }




    /* Init
    --------------------------------------------------------- */

    initSlider() {
        const { $prevBtn, $nextBtn } = this.$refs

        this.maxSlideIndex = Math.max(0, Math.floor((this.videos.length - 1) / 4))
        this.isAtStart = true
        this.isAtEnd = this.videos.length <= 4

        if ($prevBtn && $nextBtn) {
            this.bindListener($prevBtn, 'click', (e) => { this.onNavButtonClick(e, 'prev') })
            this.bindListener($nextBtn, 'click', (e) => { this.onNavButtonClick(e, 'next') })
        }
    }


    initPlayer(video, shouldPlay) {
        // if (!APP.CookieConsent.hasAccepted('functional')) return

        this.$refs.$playBtn.removeAttr('disabled')
        this.$el.removeClass('is-unplayable')

        const options = {
            ratio: '16:9',
            controls: ['play', 'progress', 'current-time', 'duration', 'mute', 'volume'],
            resetOnEnd: true,
            quality: { default: 1080 },
            fullscreen: {
                enabled: false,
            },
            keyboard: {
                global: true,
            },
            youtube: {
                // noCookie: true,
                rel: 0,
                showInfo: 0,
                cc_load_policy: 1,
                cc_lang_pref: document.documentElement.getAttribute('lang'),
            },
        }


        video.Player = new Plyr(video.$playerCtn, options)

        if (shouldPlay) {
            video.Player.on('ready', () => {
                video.Player.play()

                this.initPlayerTimer = setTimeout(() => {
                    video.$video.classList.add('is-playing')
                }, 200)

                this.initInteractiveTimer = setTimeout(() => {
                    video.$video.classList.add('is-interactive')
                }, 1000)
            })
        }
    }




    /* Values
    --------------------------------------------------------- */

    getVideos() {
        const { $video, $playerCtn, $thumb, $playBtn, $playBtnAlt, $bg } = this.$refs

        this.videos = $thumb.map(($t, index) => ({
            index,
            isCurrent: index === 0,
            isPlaying: false,
            groupIndex: Math.floor(index / 4),
            $video: $video[index],
            $thumb: $thumb[index],
            $playerCtn: $playerCtn[index],
            $playBtn: $playBtn[index],
            $playBtnAlt: $playBtnAlt[index],
            $bg: $bg[index],
        }))


        this.initPlayer(this.videos[0])

        this.videos.forEach((v) => {
            this.bindListener(v.$playBtn, 'click', (e) => { this.onPlayButtonClick(e, v) })
            this.bindListener(v.$playBtnAlt, 'click', (e) => { this.onPlayButtonClick(e, v, true) })
        })

    }

}



